export const artifactNameFallback = 'Unititled'
